import BaseOnboarding from 'onboarding/onboardings/baseonboarding';
import ConnectionsTabStep from 'onboarding/onboardings/ConnectionsOnboarding/steps/ConnectionsTabStep';
import ConnectionsChannelAndWebAnalyticStep from 'onboarding/onboardings/ConnectionsOnboarding/steps/ConnectionsChannelAndWebAnalyticStep';
import appEventBus from 'appEventBus';

class ConnectionsOnboarding extends BaseOnboarding {
  static get name () {
    return 'bindings-onboarding';
  }

  static get trackingName () {
    return 'onboarding_connections';
  }

  steps () {
    return [
      {
        target: '#page-layout-content .tabs__connections-tab',
        attachToHighlight: true,
        header: 'Привязки',
        component: ConnectionsTabStep,
        params: {
          placement: 'bottom',
          enableScrolling: true
        },
        events: {
          on () {
            window.ymReachGoal('ONBOARDING_CONNECTIONS_START');
          }
        },
        width: '408px',
        highlightTarget: '#page-layout-content .tabs__connections-tab',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 4,
          maskSizeOffsetY: 8
        }
      },
      {
        target: '#page-layout-content .nav-pills',
        attachToHighlight: true,
        header: 'Каналы и веб-аналитика',
        component: ConnectionsChannelAndWebAnalyticStep,
        params: {
          placement: 'bottom',
          enableScrolling: true
        },
        width: '408px',
        highlightTarget: '#page-layout-content .nav-pills',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 4,
          maskSizeOffsetY: 8
        },
        events: {
          off () {
            appEventBus.$emit('AUTORUN_ONBOARDING_COMPLETE');
            window.ymReachGoal('ONBOARDING_CONNECTIONS_COMPLETE');
          }
        }
      }
    ];
  }
}

export default ConnectionsOnboarding;
